// extracted by mini-css-extract-plugin
export default {"head":"PanelItem_head__QiZg3","icon":"PanelItem_icon__5JFB2","title":"PanelItem_title__J5YBO","description":"PanelItem_description__a1ju5"};